export const OBSERVABILITY_NOISE_URL_PATTERNS = [
  /^https:\/\/api2\.amplitude\.com\//,
  /^https:\/\/api-sr\.amplitude\.com\//,
  /^https:\/\/sr-client-cfg\.amplitude\.com\//,
  /^https:\/\/px\.ads\.linkedin\.com\//,
  /^https:\/\/content\.hotjar\.io\//,
  /^https:\/\/notify\.bugsnag\.com\//,
  /^https:\/\/sessions\.bugsnag\.com\//,
  /^https:\/\/oo(?:ingest|logs)\.skedsocial\.com\//,
] as const

const OBSERVABILITY_NOISE_TEXT_PATTERNS = [
  /Amplitude Logger/i,
  /\[bugsnag\]\s+(?:Event|Session) failed to send/i,
  /notify\.bugsnag\.com/i,
  /sessions\.bugsnag\.com/i,
  /api2\.amplitude\.com/i,
  /api-sr\.amplitude\.com/i,
  /sr-client-cfg\.amplitude\.com/i,
  /px\.ads\.linkedin\.com/i,
  /content\.hotjar\.io/i,
  /oo(?:ingest|logs)\.skedsocial\.com/i,
] as const

export function isObservabilityNoiseUrl(url: string) {
  return OBSERVABILITY_NOISE_URL_PATTERNS.some((pattern) => pattern.test(url))
}

export function isObservabilityNoiseText(text: string) {
  return OBSERVABILITY_NOISE_TEXT_PATTERNS.some((pattern) => pattern.test(text))
}

export function isObservabilityNoise(
  ...parts: Array<string | null | undefined>
) {
  const combined = parts.filter(Boolean).join('\n')

  return combined.length > 0 && isObservabilityNoiseText(combined)
}
